var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.875 27.1737V21.2582C11.875 19.4428 13.2738 17.9718 15 17.9718C16.7262 17.9718 18.125 19.4428 18.125 21.2582V27.1737H25V15.8869C25 15.1902 24.7362 14.5211 24.2675 14.0282L15.8837 5.21145C15.395 4.69746 14.6038 4.69746 14.1163 5.21145L5.7325 14.0282C5.26375 14.5211 5 15.1902 5 15.8869V27.1737H11.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.188b851e74cf1305d2c349ce7492d0f8.svg";
export { ForwardRef as ReactComponent };